import { Image } from 'react-native'
import { Images as foundationImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

const Images = {
  chevronRightRed: foundationImages.ic_chevron_right_red,

  vf_logo: foundationImages.vfLogo,
  celebrate: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/celebrate.png'),
  ),
  tick: Image.resolveAssetSource(require('./../Images/Icons/HIFI/tick.png')),
  tick_white: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/tick_white.png'),
  ),

  vcoins_white: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/vcoins-line-white.png'),
  ),
  vcoins_grey: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/vcoins-line-grey.png'),
  ),
  balance: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/coins.png'),
  ),
  call: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/call.png'),
  ),
  contact: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/contact.png'),
  ),
  contact_white: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/contact_white.png'),
  ),

  info: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/info_white.png'),
  ),
  close: foundationImages.ic_close,

  info_black: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/info.png'),
  ),
  recharge: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/saving.png'),
  ),
  error: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/warning.png'),
  ),

  mobileData: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/mobileData.png'),
  ),

  //HIFI images
  openBox: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/openBox.png'),
  ),
  bill: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/bill.png'),
  ),
  coins: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/saving.png'),
  ),

  warning_dark: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/warning_dark.png'),
  ),
  warning: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/warning.png'),
  ),


}

export default Images
